import React from "react";
import { Control, Controller } from "react-hook-form";
import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { INPUT_FIELD_ERROR_HELPER_SX, InputFieldError } from "../../../../styles/styledComponents";
import { IUsStateOption } from "../../../../config/usStates";

interface IPrequalStateSelectProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  options: IUsStateOption[];
}

// MUI (non-native) select so the open menu can be styled to the design
// (Figma 35836-454952) — the shared select controllers wrap NativeSelect,
// whose dropdown is OS-drawn and unstylable.
const MENU_PROPS = {
  PaperProps: {
    sx: {
      "marginTop": "0.25rem",
      "maxHeight": 320,
      "border": "1px solid #E8DFD7",
      "borderRadius": "0.5rem",
      "boxShadow": "2px 2px 18px 0px rgba(55, 54, 23, 0.30)",
      "& .MuiMenuItem-root": {
        fontSize: "0.8125rem",
        padding: "0.625rem 0.75rem",
      },
      "& .MuiMenuItem-root.Mui-selected": {
        backgroundColor: "#F4EFEB",
      },
    },
  },
} as const;

export const PrequalStateSelect = ({
  control,
  name,
  placeholder,
  options,
}: IPrequalStateSelectProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <FormControl fullWidth error={!!fieldState.error}>
        <Select
          {...field}
          value={field.value ?? ""}
          displayEmpty
          variant="standard"
          disableUnderline
          IconComponent={ExpandMoreIcon}
          renderValue={(value) =>
            value ?
              options.find((option) => option.value === value)?.label ?? String(value) :
              <span className="text-gray-1">{placeholder}</span>
          }
          sx={{
            "& .MuiSelect-select": {
              backgroundColor: "transparent",
              fontSize: "0.8125rem",
              padding: "0.6875rem 0.75rem",
              borderRadius: "0.5rem",
            },
            "& .MuiSvgIcon-root": {
              fontSize: "1.25rem",
              marginRight: "0.5rem",
            },
          }}
          MenuProps={MENU_PROPS}
          inputProps={{ id: name }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {fieldState.error?.message && (
          <FormHelperText component="div" sx={INPUT_FIELD_ERROR_HELPER_SX}>
            <InputFieldError severity="error">{fieldState.error.message}</InputFieldError>
          </FormHelperText>
        )}
      </FormControl>
    )}
  />
);

export default PrequalStateSelect;
